// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3SnOs","content":"LoadingAlert_content__3SvD_"};